<template>
  <div>
    <v-date-picker v-model="selectDate" full-width class="mt-3"></v-date-picker>
    <v-card class="ma-2 pa-2" v-for="match in matchList" :key="match.fixId">
      <v-card-title>
        <v-layout column>
          <v-flex class="subheading" xs12>{{match.matchTime}} {{match.weekName}} {{match.matchName}}</v-flex>
          <v-flex class="indigo white--text title text-xs-center" xs12>
            <span class="headline blue--text">{{match.concede}}</span>
            {{match.homeTeam}}
            <span
              class="headline red--text"
              v-if="match.wholeScore"
            >{{match.wholeScore}}</span>
            <span v-else>VS</span>
            {{match.guestTeam}}
          </v-flex>
          <v-layout column class="title green white--text text-xs-center">
            <v-flex v-if="match.xspfSp" xs12>{{match.xspfSp}}</v-flex>
            <v-flex v-if="match.spfSp" xs12>{{match.spfSp}}</v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider class="mb-2"/>

      <v-card-text>
        <v-layout v-if="match.ouPanList" class="title blue white--text text-xs-center">
          <v-layout column v-for="(ouPan, index) in match.ouPanList" :key="index">
            <span>{{ouPan.firstWinOdds | oddsConvert }} {{ouPan.firstDrowOdds | oddsConvert}} {{ouPan.firstLoseOdds | oddsConvert }}</span>
            <span>{{ouPan.winOdds | oddsConvert }} {{ouPan.drowOdds | tapeConvert}} {{ouPan.loseOdds | oddsConvert }}</span>
          </v-layout>
        </v-layout>

        <v-layout v-if="match.yaPanList" class="title orange white--text text-xs-center">
          <v-layout column v-for="(yaPan, index) in match.yaPanList" :key="index">
            <span>{{yaPan.firstHostOdds | oddsConvert }} [{{yaPan.firstTape | tapeConvert}}] {{yaPan.firstAwayOdds | oddsConvert }}</span>
            <span>{{yaPan.hostOdds | oddsConvert }} [{{yaPan.tape | tapeConvert}}] {{yaPan.awayOdds | oddsConvert }}</span>
          </v-layout>
        </v-layout>

        <v-layout v-if="match.dxPanList" class="title red white--text text-xs-center">
          <v-layout column v-for="(dxPan, index) in match.dxPanList" :key="index">
            <span>{{dxPan.firstHostOdds | oddsConvert }} [{{dxPan.firstTape | tapeConvert}}] {{dxPan.firstAwayOdds | oddsConvert }}</span>
            <span>{{dxPan.hostOdds | oddsConvert }} [{{dxPan.tape | tapeConvert}}] {{dxPan.awayOdds | oddsConvert }}</span>
          </v-layout>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-btn :id="match.fixId" color="info" @click="onCheckMatch(match)">Check</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  async created() {
    const today = new Date()
      .toISOString()
      .split("T")[0]
      .split("-")
      .join("")
      .substr(-6);
    this.loadData(today);
  },
  mounted() {
    // debugger;
  },
  data() {
    return {
      matchList: false,
      tournament: {},
      selectDate: new Date().toISOString().substr(0, 10)
    };
  },
  watch: {
    selectDate(val, old) {
      if (!val) return;
      const toDate = val
        .split("-")
        .join("")
        .substr(-6);

      this.loadData(toDate);
    }
  },
  filters: {
    oddsConvert(oddstr) {
      return oddstr ? (parseInt(oddstr) / 10000).toFixed(2) : "";
    },
    tapeConvert(tapestr) {
      return tapestr ? (parseInt(tapestr) / 10000).toFixed(2) : "";
    }
  },
  methods: {
    async loadData(toDate) {
      if (!toDate || toDate.length != 6) return;

      this.$vs.loading({
        type: "sound"
      });

      const { type } = this.$route.params;
      // const matchLists = await this.$http.get("football/oncc/list/live");
      // const matchLists = await this.$http.get("football/oncc/list/past");
      // const matchLists = await this.$http.get(`football/oncc/list/${type || 'live'}`);

      const matchLists = await this.$http.get(`football/aicai/list/${toDate}`);
      this.$vs.loading.close();

      this.matchList = matchLists.data || [];
    },
    async onCheckMatch(match) {
      const { fixId } = match;
      if (!fixId) return false;

      const _this = this;

      this.$vs.loading();

      let ouPan, yaPan, dxPan;

      await Promise.all([
        (ouPan = await this.$http.get(`football/aicai/oupan/${fixId}`)),
        (yaPan = await this.$http.get(`football/aicai/yaPan/${fixId}`)),
        (dxPan = await this.$http.get(`football/aicai/dxPan/${fixId}`))
      ]);

      ouPan = ouPan.data;
      yaPan = yaPan.data;
      dxPan = dxPan.data;

      const ouPanList = ouPan.filter(
        // company => company.companyName == "竞彩官方"
        company => company.companyName.indexOf("365") > -1
      );

      const yaPanList = yaPan.filter(
        //   company => company.companyName == "明陞"
        company => company.companyName.indexOf("365") > -1
      );

      const dxPanList = dxPan.filter(
        //   company => company.companyName == "明陞"
        company => company.companyName.indexOf("365") > -1
      );

      this.$set(match, "ouPanList", ouPanList);
      this.$set(match, "yaPanList", yaPanList);
      this.$set(match, "dxPanList", dxPanList);

      this.$vs.loading.close();

      // debugger;

      //   const { tape, firstTape } = conpanyMain;
      //   this.yaPanList = tape != firstTape ? conpanyMain : {};
    }
  }
};
</script>

<style>
td > .v-btn {
  color: black !important;
}
</style>
